import * as React from 'react';

import EoiWidgetContainer from 'bundles/expression-of-interest/components/xddp/EoiWidgetContainer';
import { ACTION_TYPES } from 'bundles/expression-of-interest/constants';
import type { EoiButtonType } from 'bundles/expression-of-interest/types';
import type { EnrollmentFlowProps } from 'bundles/premium-certificate/types';
import { trackApplyClick, trackEmailMeInfoClick } from 'bundles/premium-certificate/utils';

import _t from 'i18n!nls/premium-certificate';

const ExternalLinkFlow = ({
  actionBarData,
  slug,
  mastertrackId,
  certificateName,
  certificateType,
  expressionOfInterestContainer,
}: EnrollmentFlowProps) => {
  let enrollButton: EoiButtonType | null = null;

  if (expressionOfInterestContainer?.applyButtonUrl) {
    const enrollButtonUrl = expressionOfInterestContainer.applyButtonUrl;
    const enrollButtonText = expressionOfInterestContainer?.applyButtonText;

    enrollButton = {
      actionType: ACTION_TYPES.apply,
      doAction: () => trackApplyClick(slug, mastertrackId, certificateName, certificateType),
      isExternalLink: true,
      buttonOptions: {
        label: enrollButtonText || _t('Enroll'),
        trackingName: 'apply',
        trackingData: { section: 'headerBanner' },
        tag: 'a',
        htmlAttributes: {
          href: enrollButtonUrl,
          target: '_blank',
          rel: 'noopener noreferrer',
        },
      },
    };
  }

  const emailMeInfoButton: EoiButtonType = {
    actionType: ACTION_TYPES.emailMeInfo,
    doAction: () => trackEmailMeInfoClick(slug, mastertrackId, certificateName, certificateType),
  };

  return (
    <div data-test="ExternalLinkFlow">
      <EoiWidgetContainer
        slug={slug}
        degreeId={mastertrackId || ''}
        actionBarData={actionBarData}
        applicationUrl={expressionOfInterestContainer?.applyButtonUrl || ''}
        programInterestText={expressionOfInterestContainer?.programInterestText || ''}
        enrollButtonData={enrollButton}
        emailMeInfoButtonData={emailMeInfoButton}
      />
    </div>
  );
};

export default ExternalLinkFlow;
